import { STORE_URLS } from "@/config/site";
import { getPlatform } from "@/lib/device";
import { useWaitlist } from "@/context/WaitlistContext";

const APPLE =
  "M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701";
const PLAY =
  "M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594zM1.337.924a1.486 1.486 0 0 0-.112.568v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924zm12.207 10.065l3.258-3.238L3.45.195a1.466 1.466 0 0 0-.946-.179l11.04 10.973zm0 2.067l-11 10.933c.298.036.612-.016.906-.183l13.324-7.54-3.23-3.21z";

const STORES = [
  { key: "ios", top: "Download on the", name: "App Store", path: APPLE },
  { key: "android", top: "Get it on", name: "Google Play", path: PLAY },
];

const Badge = ({ store, href, highlighted, onClick, idPrefix }) => {
  const Tag = href ? "a" : "button";
  const live = Boolean(href);
  return (
    <Tag
      href={href || undefined}
      type={href ? undefined : "button"}
      onClick={href ? undefined : onClick}
      target={href ? "_blank" : undefined}
      rel={href ? "noopener noreferrer" : undefined}
      data-testid={`${idPrefix}-${store.key}`}
      aria-label={live ? `${store.top} ${store.name}` : `${store.name} — coming soon, join the waitlist`}
      className={`group relative flex h-14 min-w-[172px] items-center gap-3 border px-4 text-left transition-[border-color,background-color,transform] duration-300 ease-out-expo hover:-translate-y-0.5 ${
        highlighted ? "border-pa-orange bg-pa-orange/[0.07]" : "border-white/20 hover:border-white/50"
      }`}
    >
      <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0 fill-pa-ink" aria-hidden="true"><path d={store.path} /></svg>
      <span className="leading-none">
        <span className="block text-[10px] uppercase tracking-[0.12em] text-pa-muted">{live ? store.top : "Coming soon to"}</span>
        <span className="mt-1 block text-[17px] font-semibold text-pa-ink">{store.name}</span>
      </span>
    </Tag>
  );
};

export const StoreBadges = ({ idPrefix = "store-badge", source = "store-badge", className = "" }) => {
  const { openWaitlist } = useWaitlist();
  const platform = getPlatform();
  const ordered = platform === "android" ? [...STORES].reverse() : STORES;
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {ordered.map((s) => (
        <Badge
          key={s.key}
          store={s}
          href={STORE_URLS[s.key]}
          highlighted={platform === s.key}
          idPrefix={idPrefix}
          onClick={() => openWaitlist({ source: `${source}-${s.key}` })}
        />
      ))}
    </div>
  );
};
